export default __webpack_public_path__ + "static/media/p03 p03.a45f5597.jpg";